<script setup>
const { t } = useI18n()
const { features, setFeatureAsync } = useFeatures()

async function toggle() {
  await setFeatureAsync('customer_v2_calendar_user_toggle', !features.customer_v2_calendar_user_toggle)
}
</script>

<template>
  <DSSwitch
    class="text-xs text-text-400"
    :checked="features.customer_v2_calendar_user_toggle"
    :label="t('View New Calendar')"
    @click="toggle"
  />
</template>

<style lang="scss" scoped>
[data-ds-component='switch'] {
  @apply text-xs text-text-400;
}
</style>
